import React, { useEffect, useState } from 'react'
import styles from './pCustomize.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFutbol } from '@fortawesome/free-regular-svg-icons'
import { AiOutlineDown } from "react-icons/ai";
import { AiOutlineUp } from "react-icons/ai";
import Navbar from '../NavbarFooter/Navbar'
import Footer from '../NavbarFooter/Footer'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { addCart } from '../Redux/CartSlice';
import axios from 'axios';
import guide from '../../assets/guide.jpg'
import { v4 as uuidv4 } from 'uuid';
import { setLPID } from '../Redux/LastProductSlice';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function ProductCustomize(props) {

    const [product, setProduct] = useState([]);
    const [backPhoto, setBackPhoto] = useState();
    // const [frontPhoto, setFrontPhoto] = useState();
    const [proName, setProName] = useState();
    const [image, setImage] = useState();
    const [price, setPrice] = useState();
    const [size, setSize] = useState("");
    const [quantity, setQuantity] = useState(1);
    const { id } = useParams();

    useEffect(() => {
        axios.get(`https://sportsblendserver.netlify.app/.netlify/functions/api/displayOneProduct/${id}`)
            .then((res) => {
                // console.log("The photos or data are", res.data);
                setProduct(res.data);
                if(res.data.category === "65380ddac794fcf8d4778bd5") {
                    setBackPhoto(res.data.photo[1]);
                } else {
                    // console.log('photo = ', res.data.photo);
                    // console.log('photo[0] = ', res.data.photo[0]);
                    setBackPhoto(res.data.photo[0]);
                } 
            })
            .catch((err) => console.log(err));
    }, [id]);

    useEffect(() => {
        if (product.photo && product.photo[1]) {
            setBackPhoto(product.photo[1]);
            setProName(product.name);
            setImage(`https://sportsblendserver.netlify.app/.netlify/images?url=/images/${product.photo[0]}`);
            setPrice(product.price);
        }

        if (product.photo && !product.photo[1])
            {
                setImage(`https://sportsblendserver.netlify.app/.netlify/images?url=/images/${product.photo[0]}`);
                setBackPhoto(product.photo[0]);
            }
        
    }, [product]);


    const [name, setName] = useState("");
    const [num, setNum] = useState("");
    const [toggle1, setToggle1] = useState(false);
    const [toggle2, setToggle2] = useState(false);
    const [toggle3, setToggle3] = useState(false);


    const changeArrow1 = () => {
        const up = document.getElementById('up');
        const down = document.getElementById('down');
        setToggle1(!toggle1);
        if (toggle1 === true) {
            down.style.display = 'none';
            up.style.display = 'block';
        }
        else {
            down.style.display = 'block';
            up.style.display = 'none';

        }
    }

    const changeArrow2 = () => {
        const up2 = document.getElementById('up2');
        const down2 = document.getElementById('down2');

        setToggle2(!toggle2);
        if (toggle2 === true) {
            down2.style.display = 'none';
            up2.style.display = 'block';
        }
        else {
            down2.style.display = 'block';
            up2.style.display = 'none';

        }
    }

    const changeArrow3 = () => {
        const up3 = document.getElementById('up3');
        const down3 = document.getElementById('down3');
        setToggle3(!toggle3);
        if (toggle3 === true) {
            down3.style.display = 'none';
            up3.style.display = 'block';
        }
        else {
            down3.style.display = 'block';
            up3.style.display = 'none';

        }
    }
    const add = () => {
        if (quantity < 10)
            setQuantity(quantity + 1);
    }

    const minus = () => {
        if (quantity !== 1) {
            setQuantity(quantity - 1);
        }
    }

    const changeText = (e) => {
        setName(e.target.value);
    }

    const changeNum = (e) => {
        if ((e.target.value < 100 && e.target.value > 0) || e.target.value === "") {
            setNum(e.target.value);
        }
    }

    const [colorChange, setColorchange] = useState("");
    const changeNavbarColor = () => {
        if (window.scrollY >= 10) {
            setColorchange(" rgb(70, 70, 70)");
        }
        else {
            setColorchange("");
        }
    };
    window.addEventListener('scroll', changeNavbarColor);

    const today = new Date();
    let month = today.getMonth() + 1;
    let imonth = today.getMonth() + 1;
    let year = today.getFullYear();
    let iyear = today.getFullYear();
    let date = today.getDate();
    let temp = date;
    let inc = 7;

    if (date + inc > 30) {
        month = month + 1;
        date = date - 30;
        if (month > 12) {
            month = 1;
            year = year + 1;
        }
    }

    if (date + 1 > 30) {
        month = month + 1;
        date = date - 30;
        if (month > 12) {
            month = 1;
            iyear = iyear + 1;
        }
    }

    const notify = () => {
        toast.success(`Item added to cart!`, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
        });
    };
    const iDate = `${temp + 1}/${imonth}/${iyear}`;
    const lDate = `${date + inc}/${month}/${year}`;

    //////////////////////////////////

    const dispatch = useDispatch();
    const navigate = useNavigate('');
    const userID = useSelector((state) => state.user.userID);

    ////////////////////


    const handleSizeChange = (e) => {
        setSize(e.target.value);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (userID === "") {
            setProName(product.name);
    
            setPrice(product.price);
            const tempprice = product.price.replace(/,/g, ''); // Convert the string to an integer
            const intPrice = parseInt(tempprice, 10); // Convert the string to an integer
            const totalPrice = quantity * intPrice; // Calculate the total price for this item 
       
            // Dispatch the action to add the item to the cart
            const idUU = uuidv4();
            const newCart = {
                id: idUU,
                productID: id,
                image,
                proName: product.name,
                quantity,
                price: product.price,
                name: name,
                number: num,
                size,
                subtotal: totalPrice,
                total: totalPrice, // Set the total price for this item
            };
            // console.log(`\n\nadd cart = jallaaa LPI ${newCart.productID} \n ${newCart.proName}\n\n\n${JSON.stringify(newCart)}\n\n\n\n`);
            dispatch(setLPID(newCart));
            // dispatch(addCart(newCart));
            setQuantity(1);
            setSize("");

            console.log(newCart);
            navigate('/login');
        }
        else {

            // console.log(`The newProuct Ib  = ${id}\n\n`);
            // console.log(`\n\nTHe User  ID issadasd ${userID}\n\n`);
            setProName(product.name);

            setPrice(product.price);
            const tempprice = product.price.replace(/,/g, ''); // Convert the string to an integer
            const intPrice = parseInt(tempprice, 10); // Convert the string to an integer
            const totalPrice = quantity * intPrice; // Calculate the total price for this item


            // Dispatch the action to add the item to the cart
            const idUU = uuidv4();
            const newCart = {
                id: idUU,
                productID: id,
                proName: product.name,
                quantity,
                subtotal: totalPrice,
                total: totalPrice, // Set the total price for this item
                name: name,
                number: num,
                size,
                price: product.price,
                image,
            };

            dispatch(addCart(newCart));
            try {
                const toSaveItem = await axios.post("https://sportsblendserver.netlify.app/.netlify/functions/api/createCart", {
                    user_id: userID,
                    product_id: id,
                    quantity: quantity,
                    name: name,
                    number: num,
                    size: size,
                });

                // console.log(`\n\nThe product is saved in database\n${toSaveItem}`)

            }
            catch (error) {
                console.error("Error in saving cart item in db, Login.js", error);
            }
            // console.log(`\n\nadd cart = jallaaa new cart ${newCart.productID} \n ${newCart.proName}\n\n\n\n\n\n\n`);
            setQuantity(1);
            setSize("");
            notify();
            // navigate(`/productCustomize/${id}`);
        }
    }




    return (
        <div className='mpBG'>
            <Navbar bgcolor={colorChange} />

            <div className={styles.mainDiv}/* style={{ backgroundImage: `url(${props.image})` }}*/>
                {product.category === '65380ddac794fcf8d4778bd5' ?
                    (<div className={styles.mainDivContent}>
                        <div style={{ padding: '2%' }}>
                            <FontAwesomeIcon icon={faFutbol} />
                            <h1 className={styles.Hero}>Customize<br />Your Own {props.sportTitle} Jersey!</h1>
                        </div>
                        <div className={styles.custSection}>
                            {/* Customize Card */}
                            <div className={styles.cardMainDiv}>
                                <div className={styles.cardSuperDiv}>
                                    <div className={styles.card} style={{ backgroundImage: `url(https://sportsblendserver.netlify.app/.netlify/images?url=/images/${backPhoto})` }}>
                                        <div className={styles.playerName}>
                                            <h1 style={{ userSelect: 'none' }}>{name}</h1>
                                        </div>
                                        <div className={styles.playerNum}>
                                            <h1 style={{ userSelect: 'none' }}>{num}</h1>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.shirtOptions}>
                                <div className={styles.shirtDetails}>
                                    <form onSubmit={handleSubmit}>

                                        <div className={styles.shirtHeader}>
                                        <h3 className={styles.titleH1}>{product.name}</h3>
                                            <h6 className={styles.headH} style={{ textAlign: 'start' }}>PKR {product.price}</h6>
                                        </div>
                                        <div className={styles.nameDiv}>
                                            <h3>Customize</h3>
                                            <input type="text" required placeholder='Enter your name' className={styles.inputName} onChange={changeText} />
                                            <input type="number" required placeholder='Input number' className={styles.inputName} onChange={changeNum} min='1' max='99' maxLength='2' />
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '50%' }}>

                                            <div className={styles.shirtSize}>
                                                <h3>Size</h3>
                                                <select required value={size} onChange={handleSizeChange}>
                                                    <option value="">Select Option</option>
                                                    <option value="S">S</option>
                                                    <option value="M">M</option>
                                                    <option value="L">L</option>
                                                    <option value="XL">XL</option>
                                                    <option value="2XL">2XL</option>
                                                </select>
                                            </div>
                                            <div className={styles.shirtAddAndCart} >

                                                <div className={styles.shirtAdd}>
                                                    <button type='button' onClick={minus}>-</button>
                                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>

                                                        <p>{quantity}</p>
                                                    </div>
                                                    <button type='button' onClick={add}>+</button>
                                                </div>
                                                <button style={{ marginTop: '2%' }} type='submit' className={styles.shirtAddToCart} >ADD TO CART</button>
                                                <ToastContainer
                                                    position="bottom-right"
                                                    autoClose={3000}
                                                    hideProgressBar
                                                    newestOnTop={false}
                                                    closeOnClick
                                                    rtl={false}
                                                    pauseOnFocusLoss
                                                    draggable
                                                    pauseOnHover
                                                    theme="colored"
                                                />
                                            </div>
                                            <div className={styles.shirtDelivery}>
                                                <h1>Approximate delivery between {iDate} - {lDate}</h1>
                                            </div>

                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className={styles.productDetails}>
                            <div className={styles.Details} onClick={() => changeArrow1()}>
                                <h1>Details</h1>
                                <div style={{ width: '2%', display: 'flex', alignItems: 'center' }}>
                                    <AiOutlineDown id='up' /><AiOutlineUp className={styles.iconUp} id='down' style={{ display: 'none' }} />
                                </div>
                            </div>
                            {toggle1 && (
                                <div className={styles.detailsExtended}>
                                    <pre>
                                        {product.details}
                                    </pre>
                                </div>)}
                            <div className={styles.Details} onClick={() => changeArrow2()}>
                                <h1>Size Guide</h1>
                                <div style={{ width: '2%', display: 'flex', alignItems: 'center' }}>
                                    <AiOutlineDown id='up2' /><AiOutlineUp className={styles.iconUp} id='down2' style={{ display: 'none' }} />
                                </div>
                            </div>
                            {toggle2 && (<div className={styles.detailsExtended}>
                                <p>
                                    Consult the size station, compare the measurements with your favorite T-shirt (sweatshirt, pants, etc ...).
                                    Click on the button below.
                                </p>
                                <button onClick={() => window.open(guide, "_blank")} className={styles.shirtAddToCart} style={{ height: '40px', width: '150px', margin: '10px 0%', backgroundColor: 'transparent' }}>See Guide</button>
                            </div>)}
                            <div className={styles.Details} onClick={() => changeArrow3()}>
                                <h1>Shipping</h1>
                                <div style={{ width: '2%', display: 'flex', alignItems: 'center' }}>
                                    <AiOutlineDown id='up3' /><AiOutlineUp className={styles.iconUp} id='down3' style={{ display: 'none' }} />
                                </div>
                            </div>
                            {toggle3 && (<div className={styles.detailsExtended}>
                                <p>
                                    Generally your order will be entrusted to the courier within 24 hours and will be delivered to you in 2/3 working days. To track the shipment you will receive a tracking code via email.
                                    <br /><br />
                                    You can return your order within 14 days of receiving the product, free of charge and for any reason.
                                </p>
                            </div>)}
                        </div>
                    </div>
                    ) : (
                        <div className={styles.mainDivContent}>
                            <div className={styles.custSection}>
                                {/* Customize Card */}
                                <div className={styles.cardMainDiv}>
                                    <div className={styles.cardSuperDiv}>
                                        <div className={styles.card} style={{ backgroundImage: `url(https://sportsblendserver.netlify.app/.netlify/images?url=/images/${backPhoto})` }}>
                                            <div className={styles.playerName}>
                                                <h1 style={{ userSelect: 'none' }}>{name}</h1>
                                            </div>
                                            <div className={styles.playerNum}>
                                                <h1 style={{ userSelect: 'none' }}>{num}</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={styles.shirtOptions}>
                                    <div className={styles.shirtDetails}>
                                        <form onSubmit={handleSubmit}>

                                            <div className={styles.shirtHeader}>
                                                <h3 className={styles.titleH1}>{product.name}</h3>
                                                <h6 className={styles.headH} style={{ textAlign: 'start' }}>PKR {product.price}</h6>
                                            </div> 
                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '50%' }}>

                                                <div className={styles.shirtSize}>
                                                    <h3>Size</h3>
                                                    <select required value={size} onChange={handleSizeChange}>
                                                        <option value="">Select Option</option>
                                                        <option value="S">S</option>
                                                        <option value="M">M</option>
                                                        <option value="L">L</option>
                                                        <option value="XL">XL</option>
                                                        <option value="2XL">2XL</option>
                                                    </select>
                                                </div>
                                                <div className={styles.shirtAddAndCart} >

                                                    <div className={styles.shirtAdd}>
                                                        <button type='button' onClick={minus}>-</button>
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>

                                                            <p>{quantity}</p>
                                                        </div>
                                                        <button type='button' onClick={add}>+</button>
                                                    </div>
                                                    <button style={{ marginTop: '2%' }} type='submit' className={styles.shirtAddToCart} >ADD TO CART</button>
                                                    <ToastContainer
                                                        position="bottom-right"
                                                        autoClose={3000}
                                                        hideProgressBar
                                                        newestOnTop={false}
                                                        closeOnClick
                                                        rtl={false}
                                                        pauseOnFocusLoss
                                                        draggable
                                                        pauseOnHover
                                                        theme="colored"
                                                    />
                                                </div>
                                                <div className={styles.shirtDelivery}>
                                                    <h1>Approximate delivery between {iDate} - {lDate}</h1>
                                                </div>

                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.productDetails}>
                            <div className={styles.Details} onClick={() => changeArrow1()}>
                                <h1>Details</h1>
                                <div style={{ width: '2%', display: 'flex', alignItems: 'center' }}>
                                    <AiOutlineDown id='up' /><AiOutlineUp className={styles.iconUp} id='down' style={{ display: 'none' }} />
                                </div>
                            </div>
                            {toggle1 && (
                                <div className={styles.detailsExtended}>
                                    <pre>
                                        {product.details}
                                    </pre>
                                </div>)}
                            <div className={styles.Details} onClick={() => changeArrow2()}>
                                <h1>Size Guide</h1>
                                <div style={{ width: '2%', display: 'flex', alignItems: 'center' }}>
                                    <AiOutlineDown id='up2' /><AiOutlineUp className={styles.iconUp} id='down2' style={{ display: 'none' }} />
                                </div>
                            </div>
                            {toggle2 && (<div className={styles.detailsExtended}>
                                <p>
                                    Consult the size station, compare the measurements with your favorite T-shirt (sweatshirt, pants, etc ...).
                                    Click on the button below.
                                </p>
                                <button onClick={() => window.open(guide, "_blank")} className={styles.shirtAddToCart} style={{ height: '40px', width: '150px', margin: '10px 0%', backgroundColor: 'transparent' }}>See Guide</button>
                            </div>)}
                            <div className={styles.Details} onClick={() => changeArrow3()}>
                                <h1>Shipping</h1>
                                <div style={{ width: '2%', display: 'flex', alignItems: 'center' }}>
                                    <AiOutlineDown id='up3' /><AiOutlineUp className={styles.iconUp} id='down3' style={{ display: 'none' }} />
                                </div>
                            </div>
                            {toggle3 && (<div className={styles.detailsExtended}>
                                <p>
                                    Generally your order will be entrusted to the courier within 24 hours and will be delivered to you in 2/3 working days. To track the shipment you will receive a tracking code via email.
                                    <br /><br />
                                    You can return your order within 14 days of receiving the product, free of charge and for any reason.
                                </p>
                            </div>)}
                        </div>
                        </div>
                    )}
            </div>
            <Footer />
        </div>
    )
}

export default ProductCustomize